export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEFR0JULUhhFCEiAIQ/AACEPgYAhFYAAbwYAACEVwQNhEY+ALwagyIAhEIGAYREAgCEPQEAvBsLAYRAAQC8HAEAhEMbALwdAQC8HgEAhFgbAIRUAQCEVQAAvB8=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/GBT-V.bcmap
// module id = 648
// module chunks = 502